"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarNames = void 0;
var AvatarNames;
(function (AvatarNames) {
    AvatarNames["AgileHooligan1_1"] = "AgileHooligan1_1";
    AvatarNames["AgileHooligan1_2"] = "AgileHooligan1_2";
    AvatarNames["AgileHooligan1_3"] = "AgileHooligan1_3";
    AvatarNames["AgileHooligan2_1"] = "AgileHooligan2_1";
    AvatarNames["AgileHooligan2_2"] = "AgileHooligan2_2";
    AvatarNames["AgileHooligan2_3"] = "AgileHooligan2_3";
    AvatarNames["AgileHooligan3_1"] = "AgileHooligan3_1";
    AvatarNames["AgileHooligan3_2"] = "AgileHooligan3_2";
    AvatarNames["AgileHooligan3_3"] = "AgileHooligan3_3";
    AvatarNames["AgileRanger1_1"] = "AgileRanger1_1";
    AvatarNames["AgileRanger1_2"] = "AgileRanger1_2";
    AvatarNames["AgileRanger1_3"] = "AgileRanger1_3";
    AvatarNames["AgileRanger2_1"] = "AgileRanger2_1";
    AvatarNames["AgileRanger2_2"] = "AgileRanger2_2";
    AvatarNames["AgileRanger2_3"] = "AgileRanger2_3";
    AvatarNames["AgileRanger3_1"] = "AgileRanger3_1";
    AvatarNames["AgileRanger3_2"] = "AgileRanger3_2";
    AvatarNames["AgileRanger3_3"] = "AgileRanger3_3";
    AvatarNames["GirlAmazon1_1"] = "GirlAmazon1_1";
    AvatarNames["GirlAmazon1_2"] = "GirlAmazon1_2";
    AvatarNames["GirlAmazon1_3"] = "GirlAmazon1_3";
    AvatarNames["GirlAmazon2_1"] = "GirlAmazon2_1";
    AvatarNames["GirlAmazon2_2"] = "GirlAmazon2_2";
    AvatarNames["GirlAmazon2_3"] = "GirlAmazon2_3";
    AvatarNames["GirlAmazon3_1"] = "GirlAmazon3_1";
    AvatarNames["GirlAmazon3_2"] = "GirlAmazon3_2";
    AvatarNames["GirlAmazon3_3"] = "GirlAmazon3_3";
    AvatarNames["GirlScout1_1"] = "GirlScout1_1";
    AvatarNames["GirlScout1_2"] = "GirlScout1_2";
    AvatarNames["GirlScout1_3"] = "GirlScout1_3";
    AvatarNames["GirlScout2_1"] = "GirlScout2_1";
    AvatarNames["GirlScout2_2"] = "GirlScout2_2";
    AvatarNames["GirlScout2_3"] = "GirlScout2_3";
    AvatarNames["GirlScout3_1"] = "GirlScout3_1";
    AvatarNames["GirlScout3_2"] = "GirlScout3_2";
    AvatarNames["GirlScout3_3"] = "GirlScout3_3";
    AvatarNames["SmartMedic1_1"] = "SmartMedic1_1";
    AvatarNames["SmartMedic1_2"] = "SmartMedic1_2";
    AvatarNames["SmartMedic1_3"] = "SmartMedic1_3";
    AvatarNames["SmartMedic2_1"] = "SmartMedic2_1";
    AvatarNames["SmartMedic2_2"] = "SmartMedic2_2";
    AvatarNames["SmartMedic2_3"] = "SmartMedic2_3";
    AvatarNames["SmartMedic3_1"] = "SmartMedic3_1";
    AvatarNames["SmartMedic3_2"] = "SmartMedic3_2";
    AvatarNames["SmartMedic3_3"] = "SmartMedic3_3";
    AvatarNames["SmartEngineer1_1"] = "SmartEngineer1_1";
    AvatarNames["SmartEngineer1_2"] = "SmartEngineer1_2";
    AvatarNames["SmartEngineer1_3"] = "SmartEngineer1_3";
    AvatarNames["SmartEngineer2_1"] = "SmartEngineer2_1";
    AvatarNames["SmartEngineer2_2"] = "SmartEngineer2_2";
    AvatarNames["SmartEngineer2_3"] = "SmartEngineer2_3";
    AvatarNames["SmartEngineer3_1"] = "SmartEngineer3_1";
    AvatarNames["SmartEngineer3_2"] = "SmartEngineer3_2";
    AvatarNames["SmartEngineer3_3"] = "SmartEngineer3_3";
    AvatarNames["StrongBrute1_1"] = "StrongBrute1_1";
    AvatarNames["StrongBrute1_2"] = "StrongBrute1_2";
    AvatarNames["StrongBrute1_3"] = "StrongBrute1_3";
    AvatarNames["StrongBrute2_1"] = "StrongBrute2_1";
    AvatarNames["StrongBrute2_2"] = "StrongBrute2_2";
    AvatarNames["StrongBrute2_3"] = "StrongBrute2_3";
    AvatarNames["StrongBrute3_1"] = "StrongBrute3_1";
    AvatarNames["StrongBrute3_2"] = "StrongBrute3_2";
    AvatarNames["StrongBrute3_3"] = "StrongBrute3_3";
    AvatarNames["ZombieBasic1_1"] = "ZombieBasic1_1";
    AvatarNames["ZombieFast1_1"] = "ZombieFast1_1";
    AvatarNames["ZombieFat1_1"] = "ZombieFat1_1";
    AvatarNames["ZombieStrong1_1"] = "ZombieStrong1_1";
    AvatarNames["ZombieShield1_1"] = "ZombieShield1_1";
})(AvatarNames = exports.AvatarNames || (exports.AvatarNames = {}));
//# sourceMappingURL=Avatar.js.map